module.exports = __webpack_public_path__ + "img/Barlow-Thin.fb551833.svg";